import { useMemo } from "react";
import useSWR from "swr";

import { OrganizationDetails } from "@organization/models/OrganizationDetails";

import { organizationEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

export function useGetOrganization(organizationId: string) {
  const url = organizationId
    ? organizationEndpoints.getOrganizationById(organizationId)
    : null;

  const { data, error, isLoading } = useSWR<OrganizationDetails, Error>(
    url,
    fetcher
  );

  return useMemo(
    () => ({ organization: data, isLoading, error }),
    [data, isLoading, error]
  );
}
